import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=b5ca144e&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=b5ca144e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5ca144e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5ca144e')) {
      api.createRecord('b5ca144e', component.options)
    } else {
      api.reload('b5ca144e', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=b5ca144e&scoped=true&", function () {
      api.rerender('b5ca144e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2O0CCoyP4zXFA/JS/comp/PopupDialog.vue"
export default component.exports